import type { CurrentSession } from './types/session.type';

export abstract class SessionsRepository {
  public abstract getCurrent(): Promise<CurrentSession>;
}
